import styles from "./Modals.module.scss"
import ReactPlayer from 'react-player'

function ModalVideo() {
  return <div className={`
    ${styles.wrap}
    ${styles.wrapVideo} 
  `}>
    <ReactPlayer 
      url="/videos/our-journey.mp4" 
      width="960px"
      height="540px"
      controls
      playing
    />
  </div>
}

export default ModalVideo;